import { ListEntityField } from "models/list-entity-field";
import { doDelete, doGet, doPatch, doPost, parseListPath } from "../request";
import { List } from "models/list";

export const adminDoGetListEntityFields = async (
  list: List,
  listEntityUuid: string,
) => {
  const fields = await doGet<ListEntityField[]>(
    parseListPath(list, `entity/${listEntityUuid}/fields`),
  );
  return fields;
};

export const adminDoDeleteListEntityField = async (
  list: List,
  entityUuid: string,
  fieldUuid: string,
) => {
  await doDelete(
    parseListPath(list, `entity/${entityUuid}/field/${fieldUuid}`),
  );
};

export const adminDoPatchListEntityFieldOrder = async (
  list: List,
  entityUuid: string,
  fieldUuid: string,
  order: number,
) => {
  const field = await doPatch<ListEntityField>(
    parseListPath(list, `entity/${entityUuid}/field/${fieldUuid}/order`),
    { order },
  );
  return field;
};

export const adminDoPatchListEntityField = async (
  list: List,
  entityUuid: string,
  fieldUuid: string,
  data: Partial<ListEntityField>,
) => {
  const field = await doPatch<ListEntityField>(
    parseListPath(list, `entity/${entityUuid}/field/${fieldUuid}`),
    data,
  );
  return field;
};

export const adminDoPostListEntityField = async (
  list: List,
  entityUuid: string,
  data: Partial<ListEntityField>,
) => {
  const field = await doPost<ListEntityField>(
    parseListPath(list, `entity/${entityUuid}/field`),
    data,
  );
  return field;
};
